import { useState, useRef } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputCombo from "../../helpers/InputCombo";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import InputDecimal from "../../helpers/InputDecimal";
import InputDate from "../../helpers/InputDate";
import SortBy from "../../helpers/SortBy";

import search from "../../search.png";
import AppContext from "../../AppContext";
import InputText from "../../helpers/InputText";
import Xlsx from "../../exporter/Xlsx";
import MenuTable from "../../helpers/MenuTable";

import back from "../../back.png";
import InputComboRokMiesiac from "../../helpers/InputComboRokMiesiac";


function LessonRaport(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filterParam, setFilterParam] = useState({
  
        p_zajecia_dodatkowe_id: props.id,
        rok_miesiac: '',
         

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },
    
     
        limit: 50,
        page: 1,
        pages: 1,
        show: true,

    });


    const [msgData, setMsgData] = useState(0);
 


    const [tab, setTab] = useState(null);
    const [tabC, setTabC] = useState(null);
    const [razemOb, setRazemOb] = useState(0);
    const [razemNb, setRazemNb] = useState(0);



 

    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0); //do druku

    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );




    const changeView = (e ) => {
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');

        setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = (e) => {

        setView({...view, ["v"]:"list", ["id"]:"-1" }); 
        getTab();
        
    }



   
    const getTab = () => {
            
        
        props.mainView.setProgress(-2);
    

        fetch( Config.url + '/rest_v1_kids,zajecia_dodatkowe_rp_miesiac', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);  
                        setTabC(res.dg);  

                        setRazemOb(res.razem_ob);
                        setRazemNb(res.razem_nb);

                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

        return false;
    }


 

    
    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }


    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }


    const filterClear = () => {
  
       

        setFilterParam({
                 
           p_zajecia_dodatkowe_id: props.id,
            rok_miesiac: '',
          
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },
                                       
            limit: 50,
            page: 1,
            show: true
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }

    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }



 
    
    if(tab == null)
        {
            setTab([]);
            getTab();
            setTabC([]);
        
    
            return <div>
                ...
            </div>
        }

     
    
    
        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);
            setView( {
                v:'list',
                id: -1
            });
        }


 

    var sortList = [                
        {column: "nazwisko", name: "Nazwisko"  }, 
      
]



  

    if(msgData == '0')
    {
        setMsgData(1);
         props.mainView.showDialog( "Powiadomienie", "Wybierz rok i miesiąc", "ok" , null);  
    }



    return <div className="view_content">
 

                
                <div className="bg_center">

                        <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>
                        <br/>                

                        <h3>{props.title}   (obecnych: {razemOb}, nieobecnych: {razemNb})</h3>
                        <br/>


                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 


                {
                    filterParam.show == true  &&
                    <div className="table_filter">

                                     
                        <div className="filter_controll">   
                            <label>Miesiąc: </label>                             
                            <InputComboRokMiesiac   userData={props.userData} value={filterParam.rok_miesiac}   valChange={valChangeListener} goNext={goNextNew} name="rok_miesiac" placeholder={"Dzień: "}   />
                       </div> 
 
                         <div className="filter_btn">
                            <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                            <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                        </div>

                  </div>
                } 
                           


                            <div className="table_widget">
                                            <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                            
                                                &nbsp; &nbsp;
 

                                            &nbsp; &nbsp;
                                            <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title="Zajęcia dodatkowe" />   
                                            <Csv tabRef={tab2Ref}  title="zajęciadodatkowe.csv" />                  
                                            <Xlsx tabRef={tab2Ref} title="zajęciadodatkowe.xlsx" />                  
                                            <Print tabRef={tab2Ref} />

                                            <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                                </div>

                             

                                <div ref={tabRef} className="gohide">
                                            <table className="table" ref={tab2Ref}>
                                                                <thead>
                                                                    <tr className="header">                                                                                                       
                                                                        <td className="td_left">LP</td>                                                                                                                                                                                                                                                                                                                                                                     
                                                                        <td className="">Dziecko</td>                                                                                                                                                                                                                                                                                                                                                                     
                                                                        <td className="">Umowa</td>                                                                                                                                                                                                                                                                                                                                                                     
                                                                        {
                                                                            tabC.map( (item, ix) => {
                                                                                return <td className="center">
                                                                                    {item.dzien} / {item.godzina.substr(0,5)}
                                                                                </td>
                                                                            } )
                                                                        } 
                                                                        <td className="">Razem nb.</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
                                                                        <td className="td_right">Razem ob.</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
                                                                    </tr>
                                                                </thead>
                                                                <tbody>

                                                                    {
                                                                        tab.map( (row,ix) => {

                                                                        
                                                                            var rowStyle = " row ";
                                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                                        

                                                                            return <tr className={rowStyle}>                                                                                                       
                                                                                <td>{ix+1}</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                                                <td>{row.nazwisko} {row.imie}</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                                                <td className="gocenter">{row.numer_umowy}</td>  
                                                                                {
                                                                                        row.ob.map( (sub, ix) => {
                                                                                            return <td className="gocenter">
                                                                                                {
                                                                                                    sub.status == "1" && <span>O</span>
                                                                                                } 
                                                                                                {
                                                                                                    sub.status == "0" && <span>N</span>
                                                                                                } 
                                                                                                {
                                                                                                    sub.status == "2" && <span></span>
                                                                                                } 
                                                                                            </td>
                                                                                        } )
                                                                                    }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             

                                                                                    <td className="gocenter"> 
                                                                                        {row.razem_nb}
                                                                                    </td>
                                                                                    <td className="gocenter"> 
                                                                                        {row.razem_ob}
                                                                                    </td>
                                                                            </tr>    

                                                                        } )
                                                                    }

                                                            
                                                                </tbody>
                                            </table>
                                </div>



                            <div className="scorll_x">
                                <table className="table" >
                                                    <thead>
                                                        <tr className="header">                                                                                                       
                                                            <td className="td_left">LP</td>                                                                                                                                                                                                                                                                                                                                                                     
                                                            <td className="">Dziecko</td>                                                                                                                                                                                                                                                                                                                                                                     
                                                            <td className="">Umowa</td>                                                                                                                                                                                                                                                                                                                                                                     
                                                            {
                                                                tabC.map( (item, ix) => {
                                                                    return <td className="center">
                                                                        {item.dzien} / {item.godzina.substr(0,5)}
                                                                    </td>
                                                                } )
                                                            } 
                                                            <td className="">Razem nb.</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
                                                            <td className="td_right">Razem ob.</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {
                                                            tab.map( (row,ix) => {

                                                              
                                                                var rowStyle = " row ";
                                                                if(ix % 2 == 0 )rowStyle = " row2 ";

                                                              

                                                                return <tr className={rowStyle}>                                                                                                       
                                                                    <td>{ix+1}</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                                    <td>{row.nazwisko} {row.imie}</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                                    <td className="gocenter">{row.numer_umowy}</td>  
                                                                      {
                                                                            row.ob.map( (sub, ix) => {
                                                                                return <td className="gocenter">
                                                                                     {
                                                                                        sub.status == "1" && <span>O</span>
                                                                                     } 
                                                                                     {
                                                                                        sub.status == "0" && <span>N</span>
                                                                                     } 
                                                                                      {
                                                                                        sub.status == "2" && <span></span>
                                                                                     } 
                                                                                </td>
                                                                            } )
                                                                        }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             

                                                                        <td className="gocenter"> 
                                                                            {row.razem_nb}
                                                                        </td>
                                                                        <td className="gocenter"> 
                                                                            {row.razem_ob}
                                                                        </td>
                                                                </tr>    

                                                            } )
                                                        }

                                                 
                                                    </tbody>
                                </table>
                            </div>


                </div>

                <br/>                                                            
                <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>
                <br/> 


           </div>
}




export default LessonRaport;